import { empty as observableEmpty, Subscription } from 'rxjs';

import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, distinctUntilChanged, filter, map } from 'rxjs/operators';

import { AppState } from './../../../../app';
import { BootstrapService, TradeService } from './../../../../core';

import moment from 'moment-timezone';

@Component({
  selector: 'hb-lastfivedeposit',
  templateUrl: 'lastFiveDeposit.component.html',
  styleUrls: ['./lastFiveDeposit.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LastFiveDepositComponent implements OnInit {
  @Input() transactionType: number;

  bootstrapPromise: Promise<any>;

  public headerType: any = ['Últimos depósitos', 'Últimos retiros'];

  public headerName = '';
  private date: Date;
  private deposits: any = [];
  private currentContractSubscription: Subscription;
  public showSkeleton = true;
  public totalRows = 0;
  private months: any = [
    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic',
  ];

  constructor(
    private bootstrapService: BootstrapService,
    private tradeService: TradeService,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.getHeaderName();
    this.bootstrapPromise = this.bootstrapService.initSession().then(() => {
      this.currentContractSubscription = this.store
        .select('currentContract')
        .pipe(
          map((values: any) => values.get('contractID')),
          filter((contractId: any) => contractId !== undefined),
          distinctUntilChanged(),
        )
        .subscribe((contractId: any) => {
          this.showSkeleton = true;
          this.totalRows = 0;
          this.getContractTopCashMovements(contractId);
        });
    });
  }

  getContractTopCashMovements(contractId: any) {
    this.tradeService
      .getContractTopCashMovements(contractId)
      .pipe(
        catchError((error: any) => {
          this.showSkeleton = false;
          return observableEmpty();
        }),
      )
      .subscribe((value: any) => {
        if (value !== null) {
          this.getFiveDeposit(value);
        } else {
          this.totalRows = 0;
        }
        this.showSkeleton = false;
      });
  }

  getFiveDeposit(deposits: any) {
    this.deposits =
      deposits.length > 0
        ? deposits.filter((e: any) => e.orderType === this.transactionType)
        : [];
    this.totalRows = this.deposits.length > 0 ? this.deposits.length : 0;
  }

  getHeaderName() {
    this.headerName =
      this.transactionType === 8 ? this.headerType[0] : this.headerType[1];
  }

  getFormatDate(dateTransaction: Date) {
    const dateTransac: any = moment(dateTransaction).format('L');
    const month: any = dateTransac.split('/');
    return (
      month[0] + '/' + this.months[parseInt(month[1], 10) - 1] + '/' + month[2]
    );
  }

  getFormatTime(dateTransaction: Date) {
    return new Date(dateTransaction).toLocaleTimeString();
  }
}
